import { InjectionToken } from '@angular/core';

export const STORAGE_KEY_PREFIX = new InjectionToken<string>(
  'Storage Key Prefix'
);
